import React from 'react';
import PropTypes from 'prop-types';
import { FormBuilder } from '@formio/react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@formio/js/dist/formio.full.min.css';

/**
 * Form.io drag-and-drop builder. Persist the object from `onChange` as the portal `schema`.
 * `initialForm` must stay stable while editing (only replace when loading a definition or resetting); live state is kept inside the builder and mirrored via `onChange`.
 */
const FormFormioBuilder = ({ initialForm, onChange, disabled }) => (
  <div
    style={{
      minHeight: 480,
      opacity: disabled ? 0.6 : 1,
      pointerEvents: disabled ? 'none' : 'auto',
    }}
    aria-busy={disabled}
  >
    <FormBuilder initialForm={initialForm} onChange={onChange} />
  </div>
);

FormFormioBuilder.propTypes = {
  initialForm: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

FormFormioBuilder.defaultProps = {
  disabled: false,
};

export default FormFormioBuilder;
